import { render } from "./JustoppDeal.vue?vue&type=template&id=cd0437d2"
import script from "./JustoppDeal.vue?vue&type=script&lang=js"
export * from "./JustoppDeal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__